import React from 'react';
import { Card } from '@mui/material';

const DSCard = (props: React.ComponentProps<typeof Card>) => {
  return <Card {...props} />;
};

export default DSCard;
